const { default: axiosIns } = require('@/libs/axios')

const InfoService = {
  // GET - InfoApiController
  async getSectionGroups() {
    return axiosIns.get('admin/infos')
      .then(response => response.data)
  },
  async getSectionGroup(id) {
    return axiosIns.get(`admin/infos/${id}`)
      .then(response => response.data)
  },
  async getSection(id) {
    return axiosIns.get(`admin/infos/section/${id}`)
      .then(response => response.data)
  },
  // POST - InfoApiController
  async createSectionGroup(model) {
    return axiosIns.post('admin/infos', model)
      .then(response => response.data)
  },
  async createSection(model) {
    return axiosIns.post('admin/infos/section', model)
      .then(response => response.data)
  },
  // PUT - InfoApiController
  async updateSectionGroup(model) {
    return axiosIns.put(`admin/infos/${model.id}`, model)
      .then(response => response.data)
  },
  async updateSection(model) {
    return axiosIns.put(`admin/infos/section/${model.id}`, model)
      .then(response => response.data)
  },
}

export default InfoService
